export const getScheduleInitialState = {
	schedules: null,
	error: null,
	errorShow: false,
	loading: false,
};
